import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

class AboutPage extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'
        let imagealt = 'image'

    return	<section className="service-two service-two__service-page service-two__about-page  go-top">
			  <div className="container">
			    <div className="row">
			      <div className="col-lg-6">
			        <div className="service-two__image">
			          <img src={publicUrl+"assets/images/resources/about-us-1.jpg"} alt={ imagealt } />
			        </div>{/* /.service-two__image */}
			      </div>{/* /.col-lg-6 */}
					<div className="col-lg-6">
						<div className="service-two__block">
							<div className="block-title-two text-left">
								<p>about us</p>
								<h3>Smarter Conversations <br /> Stronger Leads</h3>
							</div>

							<p>
								The Conversational Assistant and Voice Calling Assistant help businesses automate customer interactions while maintaining a human-centered experience. Whether it's property inquiries, product support, or sales leads, the platform captures every opportunity with precision and personalization.
							</p>

							<div className="feature-grid">

								<div className="feature-item">
									<i className="fas fa-robot"></i>
									<div>
										<h6>Human-like Conversational Assistant</h6>
										<p>Understands user intent, answers questions, and captures qualified leads.</p>
									</div>
								</div>

								<div className="feature-item">
									<i className="fas fa-phone-volume"></i>
									<div>
										<h6>Voice-Enabled Assistant</h6>
										<p>Handles real-time voice calls through natural, human-like conversations.</p>
									</div>
								</div>

								<div className="feature-item">
									<i className="fas fa-route"></i>
									<div>
										<h6>Intelligent Lead Routing</h6>
										<p>Sends qualified leads directly to your CRM or business portal.</p>
									</div>
								</div>

								<div className="feature-item">
									<i className="fas fa-plug"></i>
									<div>
										<h6>Easy Integration</h6>
										<p>Connect to your website with just a few lines of code.</p>
									</div>
								</div>

								<div className="feature-item">
									<i className="fas fa-shield-alt"></i>
									<div>
										<h6>Secure & Scalable</h6>
										<p>Built with enterprise-grade security, reliability, and scalability.</p>
									</div>
								</div>

							</div>

							<Link to="/service" className="thm-btn">
								Read More <i className="fa fa-angle-double-right" />
							</Link>
						</div>
					</div>
			    </div>{/* /.row */}
			  </div>{/* /.container */}
			</section>



        }
}

export default AboutPage